export const CUSTOM_FONT_PREFIX = '--font';

export const isCustomFont = (v) => (v ? v.startsWith(CUSTOM_FONT_PREFIX) : false);

export const getCustomFont = (f) => (f ? f.split(CUSTOM_FONT_PREFIX)[1] : null);
